import Service, { service } from "@ember/service";
import { ajax } from "discourse/lib/ajax";
import Category from "discourse/models/category";
import Circle from "../models/circle";

const circlesMap = {};

export default class Circles extends Service {
  @service currentUser;
  @service site;
  @service siteSettings;

  constructor() {
    super(...arguments);

    Circle.updateCustomFieldsAttributes(this.availableCustomFields);
  }

  get isCirclesEnabled() {
    return this.siteSettings.discourse_circles_enabled;
  }

  get userCanUseCircles() {
    if (!this.isCirclesEnabled) {
      return false;
    }
    if (!this.currentUser && this.siteSettings.login_required) {
      return false;
    }
    if (this.siteSettings.discourse_circles_allow_anonymous_use) {
      return true;
    }

    return !!this.currentUser?.can_use_circles;
  }

  get userCanCreateCircles() {
    return this.userCanUseCircles && !!this.currentUser?.can_create_circles;
  }

  userCanCreateTopic(circleModel) {
    return this.userCanUseCircles && !!circleModel?.can_create_topic;
  }

  userIsMember(circleModel) {
    return !!circleModel?.is_circle_member;
  }

  get availableCustomFields() {
    return this.site.circle_fields || [];
  }

  get searchableCustomFields() {
    return this.availableCustomFields.filter((field) => field.searchable);
  }

  async reloadCustomFields() {
    const response = await ajax("/circles/custom-fields");
    this.site.circle_fields = response.custom_fields;

    Circle.updateCustomFieldsAttributes(this.availableCustomFields);
    return this.availableCustomFields;
  }

  get customFilters() {
    return this.searchableCustomFields.map((field) => ({
      id: field.id,
      name: field.name,
      queryParameter: `filter_${field.name}`,
      type: field.field_type,
      options: field.options,
    }));
  }

  storeCircle(circle) {
    const circleId = circle?.category_id;
    if (!circleId) {
      return;
    }

    circle.category = Category.findById(circle.category_id);
    circlesMap[circleId] = circle;
  }

  storeCircles(circles) {
    if (!circles) {
      return;
    }

    circles.forEach((circle) => {
      this.storeCircle(circle);
    });
  }

  findCached(categoryId) {
    return circlesMap[categoryId];
  }
}
